var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandMicrosoftEdgeStyleBrand = function SvgBrandMicrosoftEdgeStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandMicrosoftEdgeStyleBrand__clip0_3952_114509)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMicrosoftEdgeStyleBrand__paint0_linear_3952_114509)",
    d: "M21.666 17.86a9 9 0 0 1-.994.44 9.6 9.6 0 0 1-3.366.6c-4.434 0-8.297-3.047-8.297-6.966a2.95 2.95 0 0 1 1.538-2.559c-4.013.169-5.044 4.35-5.044 6.797 0 6.937 6.384 7.631 7.763 7.631.74 0 1.856-.216 2.53-.431l.123-.038a12.03 12.03 0 0 0 6.244-4.95.375.375 0 0 0-.497-.525"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMicrosoftEdgeStyleBrand__paint1_radial_3952_114509)",
    d: "M21.666 17.86a9 9 0 0 1-.994.44 9.6 9.6 0 0 1-3.366.6c-4.434 0-8.297-3.047-8.297-6.966a2.95 2.95 0 0 1 1.538-2.559c-4.013.169-5.044 4.35-5.044 6.797 0 6.937 6.384 7.631 7.763 7.631.74 0 1.856-.216 2.53-.431l.123-.038a12.03 12.03 0 0 0 6.244-4.95.375.375 0 0 0-.497-.525",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMicrosoftEdgeStyleBrand__paint2_linear_3952_114509)",
    d: "M9.91 22.622a7.4 7.4 0 0 1-2.129-1.997 7.566 7.566 0 0 1 2.766-11.25c.3-.14.797-.384 1.462-.375a3.04 3.04 0 0 1 2.41 1.219 3 3 0 0 1 .59 1.753c0-.019 2.297-7.463-7.5-7.463-4.115 0-7.5 3.9-7.5 7.332a12.2 12.2 0 0 0 1.135 5.25 12 12 0 0 0 14.662 6.28 7.08 7.08 0 0 1-5.887-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMicrosoftEdgeStyleBrand__paint3_radial_3952_114509)",
    d: "M9.91 22.622a7.4 7.4 0 0 1-2.129-1.997 7.566 7.566 0 0 1 2.766-11.25c.3-.14.797-.384 1.462-.375a3.04 3.04 0 0 1 2.41 1.219 3 3 0 0 1 .59 1.753c0-.019 2.297-7.463-7.5-7.463-4.115 0-7.5 3.9-7.5 7.332a12.2 12.2 0 0 0 1.135 5.25 12 12 0 0 0 14.662 6.28 7.08 7.08 0 0 1-5.887-.75z",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMicrosoftEdgeStyleBrand__paint4_radial_3952_114509)",
    d: "M14.288 13.95c-.085.094-.32.234-.32.525 0 .244.16.488.45.684 1.341.938 3.882.807 3.891.807 1-.001 1.98-.27 2.841-.778a5.76 5.76 0 0 0 2.85-4.96c.028-2.1-.75-3.497-1.06-4.115C20.945 2.23 16.66 0 12 0A12 12 0 0 0 0 11.831C.047 8.41 3.45 5.644 7.5 5.644c.328 0 2.203.028 3.938.937a6.8 6.8 0 0 1 2.896 2.747c.572.994.675 2.26.675 2.766s-.253 1.247-.73 1.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMicrosoftEdgeStyleBrand__paint5_radial_3952_114509)",
    d: "M14.288 13.95c-.085.094-.32.234-.32.525 0 .244.16.488.45.684 1.341.938 3.882.807 3.891.807 1-.001 1.98-.27 2.841-.778a5.76 5.76 0 0 0 2.85-4.96c.028-2.1-.75-3.497-1.06-4.115C20.945 2.23 16.66 0 12 0A12 12 0 0 0 0 11.831C.047 8.41 3.45 5.644 7.5 5.644c.328 0 2.203.028 3.938.937a6.8 6.8 0 0 1 2.896 2.747c.572.994.675 2.26.675 2.766s-.253 1.247-.73 1.865z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMicrosoftEdgeStyleBrand__paint1_radial_3952_114509",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.94375 0 0 8.49656 14.738 16.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMicrosoftEdgeStyleBrand__paint3_radial_3952_114509",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.01373 -13.29071 10.73755 1.6269 6.615 18.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMicrosoftEdgeStyleBrand__paint4_radial_3952_114509",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.759 18.97503 -40.41278 -1.6165 2.427 4.436)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMicrosoftEdgeStyleBrand__paint5_radial_3952_114509",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.55412 8.757 -7.1212 2.07701 22.506 7.247)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandMicrosoftEdgeStyleBrand__paint0_linear_3952_114509",
    x1: 5.503,
    x2: 22.228,
    y1: 16.594,
    y2: 16.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandMicrosoftEdgeStyleBrand__paint2_linear_3952_114509",
    x1: 14.316,
    x2: 3.881,
    y1: 9.338,
    y2: 20.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandMicrosoftEdgeStyleBrand__clip0_3952_114509"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandMicrosoftEdgeStyleBrand);
export { ForwardRef as ReactComponent };